<template lang="pug">
    .animations(ref='animation')
        svg.teabag(width='140' viewBox='60 -15 100 400' preserveAspectRatio='xMidYMid meet')
            g(ref='teaBag')
                path(d='M138.028 223.271L118.265 223.335L99.1289 223.451L76.4074 223.583L47.858 268.705L48.5697 411.076L169.135 410.442L168.423 268.072L138.028 223.271Z' fill='black')
                path(d='M100.602 210.095L100.674 224.79L119.788 224.691L119.716 209.996L100.602 210.095Z' fill='black')
                path(d='M100.608 224.775L100.658 235.061L119.772 234.962L119.722 224.675L100.608 224.775Z' fill='black')
                line(x1='110.243' y1='49' x2='110.243' y2='220' stroke='black' stroke-width='3')
                rect(x='81.7432' width='54' height='54' fill='var(--color-red)')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(
                this.$refs.teaBag,
                {y: 0},
                {
                    keyframes: [
                        {y: -100, ease: 'none'},
                        {y: 100, ease: 'none'},
                        {y: -100, ease: 'none'}
                    ],
                    ease: 'none',
                    yoyo: true
                },
                0
            );
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.animations {
    width: 100%;
    padding-left: var(--grid-column);
    @media (--viewport-tablet) {
        padding: 0;
        display: flex;
    }
}
.teabag {
    max-height: 50vh;
    margin-right: auto;
    @media (--viewport-tablet) {
        margin: auto;
    }
}
</style>
